import './BroadcastInfo.css';
import React, {useContext} from 'react';
import twitchLogo from '../images/twitch_logo.png'; // @todo USE webp + LINK TO YOUTUBE AS WELL!
import { AppContext } from '../AppContext';
import ReactDOM from "react-dom";

class BroadcastInfo extends React.Component {
    constructor(props) {
        super(props);
    }

    get broadcastInfoHost() {
        return document.getElementById('Broadcast-Info');
    }

    _getBroadcast() {
        return this.props?.context?.components?.broadcast;
    }

    getLiveBadge() {
        const broadcast = this._getBroadcast();
        if (broadcast?.is_live) {
            return (
                <label>
                    <a href="https://www.twitch.tv/pelaajatcom" target="_blank">LIVE</a>
                </label>
            )
        }
        if (broadcast?.schedule) {
            return (
                <span>{broadcast.schedule}</span>
            )
        }
    }

    getTwitchBadge() {
        const broadcast = this._getBroadcast();
        if (broadcast?.is_live) {
            return (
                <img src={twitchLogo} alt="Twitch" />
            );
            /*return (
                <FontAwesomeIcon icon={icon({name: 'twitch', style: 'brands'})} beatFade style={{color: "#ff3300",}} />
            )*/
        }
        return (
            <img src={twitchLogo} alt="Twitch" />
        );
        /*
        return (
            <FontAwesomeIcon icon={icon({name: 'twitch', style: 'brands'})} style={{color: "#ff3300",}} />
        )*/
    }

    openBroadcast(event) {
        const broadcast = this._getBroadcast();
        event.preventDefault();
        if (broadcast?.is_live) {
            window.open('https://www.twitch.tv/pelaajatcom', '_blank');
            return;
        }
        if (broadcast?.link) {
            window.location.href = broadcast.link;
            return;
        }
        console.log('Oops.. ei linkkiä!');
    }

    render() {
        if (!this.broadcastInfoHost) {
            return null;
        }
        const broadcast = this._getBroadcast();
        if (!broadcast) {
            if (this.broadcastInfoHost.classList.contains('Broadcast-Info')) {
                this.broadcastInfoHost.classList.remove('Broadcast-Info');
            }
            this.broadcastInfoHost.onClick = null;
            return ReactDOM.createPortal((<></>), this.broadcastInfoHost);
        }
        if (!this.broadcastInfoHost.classList.contains('Broadcast-Info')) {
            this.broadcastInfoHost.classList.add('Broadcast-Info');
        }
        this.broadcastInfoHost.onClick = (event) => { this.openBroadcast(event); };
        return ReactDOM.createPortal((
            <>
                {this.getLiveBadge()}
                <div className="Title-Scroll">{broadcast.txt}</div>
                <a href="https://www.twitch.tv/pelaajatcom" target="_blank">
                    {this.getTwitchBadge()}
                </a>
            </>
        ), this.broadcastInfoHost);
    }
}

const BroadcastInfoWithContext = (props) => {
    const context = useContext(AppContext);
    return (<BroadcastInfo {...props} context={context} />);
};

export default BroadcastInfoWithContext;
